import { useEffect } from 'react';
import {
  ASSET_OWNERSHIP_FLAG,
  isClientFeatureEnabled,
} from 'api/client-feature-flags';
import { useUserProfile } from '../../api/profile';
import { updateChameleonUser } from '../../lib/chameleon';

export const ChameleonUpdater = () => {
  const { data: user } = useUserProfile();

  useEffect(() => {
    if (user) {
      updateChameleonUser({
        userId: user.id,
        email: user.email,
        organizationId: user.organizationId,
        tenantId: user.tenantId,
        name: user.name,
        assetOwnership: isClientFeatureEnabled(ASSET_OWNERSHIP_FLAG, {
          organizationId: user.organizationId,
        }),
      });
    }
  }, [user]);

  return null;
};
